
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Highlight from './UI/Highlight';

const Highlights = () => {
    return (
        <section id='highlights'>
            <div className="container">
                <div className="row">
                    <h2 className="section__title">
                        Why choose <span className='purple'>Library</span>?
                    </h2>
                    <div className="highlight__wrapper">
                        <Highlight icon={<FontAwesomeIcon icon="bolt" />} 
                        title="Easy and Quick"
                        para="Get access to the shit you purchased online instantly."
                        />
                        <Highlight icon={<FontAwesomeIcon icon="book-open" />} 
                        title="10,000+ titles available"
                        para=" Library has books in all your favorite categories."
                        />
                        <Highlight icon={<FontAwesomeIcon icon="tags" />} 
                        title="Affordable prices"
                        para="Get your favorite books at a fraction of the cost."
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Highlights;